module.exports = __webpack_public_path__ + "static/media/nu.c4f76fcb.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nu.svg
// module id = 2180
// module chunks = 0